module.exports = __webpack_public_path__ + "img/RAR_system_icon@2x.50c6e0a7.png";